export const dismissKeyboard = () => {
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }
};

export const isInputElement = (element: HTMLElement): boolean => {
  return (
    element.tagName === "INPUT" ||
    element.tagName === "TEXTAREA" ||
    element.getAttribute("contenteditable") === "true" ||
    !!element.closest("input") ||
    !!element.closest("textarea") ||
    !!element.closest("[contenteditable='true']")
  );
};

export const createDismissKeyboardHandler = () => {
  return (e: React.MouseEvent | React.TouchEvent) => {
    e.preventDefault();
    dismissKeyboard();
  };
};
